export default __webpack_public_path__ + "ee7eab0e25445838755b5df2bee05a2c.svg";